module.exports = __webpack_public_path__ + "png/quick-registration-photo-4.png?baae75baaeac33fb594f295e34b1bac8";